import * as Config from '../../config';
import { default as Locale } from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import * as MathLib from '../../utils/Math';
import { GraphIcon } from '../../utils/Icon';
import { AlertInfo, AlertLevel, AlertType, AlertRecord, AlertCategories } from "../Types";
import { AlertLogic } from './AlertLogic';
import { findAllStates } from "../../status/index";
import { ContentCategories } from "../../types";

export class Chlorine extends AlertLogic {
    static type = [
        AlertType.FreeChlorineLow,
        AlertType.FreeChlorineHigh,
        AlertType.TotalChlorineLow,
        AlertType.TotalChlorineHigh
    ];
    static category = AlertCategories.WATER_QUIALITY;
    static contentCategories = [ ContentCategories.WATER_QUALITY ];
    static title = [
        Locale.gettext('Free Chlorine Low'),
        Locale.gettext('Free Chlorine High'),
        Locale.gettext('Total Chlorine Low'),
        Locale.gettext('Total Chlorine High'),
    ];

    getInfo(alert: AlertRecord = this.alert, config:Config.AllConfig = this.allConfigs):AlertInfo {
        let { body, device, alertData, firstReported } = this.getCommons(alert, config);
        const bowUuid = (body as Config.BodyOfWaterConfig)?.UUID;

        let cardIllustration = 'pipes_emergency';
        let detailIcon = GraphIcon.getNodeIconName({
            DeviceType: Config.DeviceTypes.CHLORINESENSOR
        });
            
        const chlorineTyoeLocalized = alert.type.indexOf('FREE') === 0 ?
            this.locale.gettext('Free Chlorine') :
            this.locale.gettext('Total Chlorine')
        ;

        const lowHightLocalized = alert.type.indexOf('LOW') !== -1 ?
            this.locale.gettext('low') :
            this.locale.gettext('high')
        ;

        // alertData.CurrentValue is not updated anymore by the Controller so getting it from the states.
        const bowStates = findAllStates(bowUuid, this.states);
        const currentValue = alert.type.indexOf("FREE") === 0 ?
            (bowStates as { FreeChlorine: number | string})?.FreeChlorine :
            (bowStates as { TotalChlorine: number | string })?.TotalChlorine
        ;

        const configuredLimit = Locale.gettext("Configured limit is %2$s.",
            MathLib.formatAccuracy(alertData?.ConfiguredLimit, 0.01)
        );

        const cardDescription = (currentValue !== "null" && currentValue !== null && typeof currentValue !== "undefined") ?
            this.locale.gettext(
                'Currently reading %1$s.',
                MathLib.formatAccuracy(currentValue, 0.01),
            ) + " " + configuredLimit :
            configuredLimit
        ;

        const detailDescriptionArr = [
            cardDescription,
        ];

        const historicalDescriptionShort = [ configuredLimit ];
        
        const bowChemistry = this.allConfigs?.Chemistry?.find(item => item.BodyOfWaterUUID === bowUuid) || ({} as Config.BowChemistry);
        

        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('%1$s %2$s is %3$s', body.Name, chlorineTyoeLocalized, lowHightLocalized),
            cardDescription,
            cardIllustration: cardIllustration,
            detailIcon,
            detailDescription: null,
            detailDescriptionArr,
            historicalDescriptionShort,
            resolveSummary: this.locale.gettext('%1$s %2$s has normalized', body.Name, chlorineTyoeLocalized)
        });
        alertInfo.contentCategories = Chlorine.contentCategories;
        return alertInfo;
    }

    static mock(type:AlertType, config:Config.AllConfig, subType?:string):AlertRecord {
        const device = config.Config.Devices.find(dev => dev.DeviceType === Config.DeviceTypes.CHLORINESENSOR);
        
        const target = config.Config.BodiesOfWater[ 0 ]?.SanitizerTarget?.Target || 0.7;
        return new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device?.UUID ?? "chlorine-sensor-uuid", "MOCK"), "ALRT" + type),
            siteId: Math.floor(Math.random() * 100000),
            // deviceId: 
            entityUuid: device?.UUID,
            bodyUuid: config.Config.BodiesOfWater[ 0 ]?.UUID,
            type: type,
            level: AlertLevel.Error,
            data: {
                ConfiguredLimit: target - 0.1
            }
        });
    }
}